// src/api/cars.js
import api from "./axios";

// GET vehicles
export const getVehicles = async (params = {}) => {
  // remove empty values
  const filtered = Object.entries(params).reduce((acc, [key, val]) => {
    if (val != null && val !== "") acc[key] = val;
    return acc;
  }, {});

  // only pass params if there’s at least one key
  const config = Object.keys(filtered).length
    ? { params: filtered }
    : undefined;

  const { data } = await api.get("/vehicles", config);
  // { success, total, page, limit, totalPages, count, data: [...] }
  return data;
};

// GET Vehicles with Image count
export const getVehiclesWithImageCount = async (params = {}) => {
  // strip out empty values
  const filtered = Object.entries(params).reduce((acc, [key, val]) => {
    if (val != null && val !== "") acc[key] = val;
    return acc;
  }, {});

  // only pass params if we have any
  const config = Object.keys(filtered).length
    ? { params: filtered }
    : undefined;

  const { data } = await api.get("/vehicles/admin-with-count", config);
  return data;
};

// GET single vehicle by id
export const getCarById = async (carId) => {
  const res = await api.get(`/vehicles/${carId}`);
  return res.data;
};

// POST - add a vehicle
export const addCar = (carData) =>
  api.post(`/vehicles`, carData).then((r) => r.data);

// POST - BULK Add Basic Car Details
export async function bulkAddBasicCars(formData) {
  const res = await api.post("/vehicles/bulk-add-basic", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

// POST - BULK fetch car data from external API
export async function bulkEnrichCars() {
  const res = await api.post("/vehicles/bulk-enrich");
  return res.data;
}

// PUT - update a vehicle
export const updateCar = async (id, carData) => {
  const { thumbnail, ...payload } = carData;
  const r = await api.put(`/vehicles/${id}`, payload);
  return r.data;
};

// PUT - bulk update status
export const bulkUpdateCars = ({ ids, status }) =>
  api.patch(`/vehicles/bulk`, { ids, status }).then((r) => r.data);

// DELETE - delete a vehicle
export const deleteCar = (id) => api.delete(`/vehicles/${id}`);

// DELETE - delete multiple vehicles
export const bulkDeleteCars = (ids) =>
  api.delete(`/vehicles/bulk-delete`, { data: { ids } }).then((r) => r.data);

// GET FACETS

// 1) Makes (no filtering)
export const getMakes = () =>
  api.get("/vehicles/facets/makes").then((r) => r.data);

// 2) Models (filtered by make)
export const getModels = (make) =>
  api.get("/vehicles/facets/models", { params: { make } }).then((r) => r.data);

export const getColors = async ({
  make,
  model,
  bodyType,
  color,
  fuelType,
  transmissionType,
  mileageBucket,
}) => {
  const params = {};
  if (make) params.make = make;
  if (model) params.model = model;
  if (bodyType?.length) params.bodyType = bodyType; // array of strings
  if (color) params.color = color;
  if (fuelType?.length) params.fuelType = fuelType;
  if (transmissionType?.length) params.transmissionType = transmissionType;
  if (mileageBucket) params.mileageBucket = mileageBucket;

  const r = await api.get("/vehicles/facets/colors", { params });
  return r.data;
};

export const getBodyTypes = async ({
  make,
  model,
  bodyType, // not needed here; just read other filters
  color,
  fuelType,
  transmissionType,
  mileageBucket,
}) => {
  const params = {};
  if (make) params.make = make;
  if (model) params.model = model;
  if (color) params.color = color;
  if (fuelType?.length) params.fuelType = fuelType;
  if (transmissionType?.length) params.transmissionType = transmissionType;
  if (mileageBucket) params.mileageBucket = mileageBucket;

  const r = await api.get("/vehicles/facets/body-types", { params });
  return r.data;
};

export const getFuelTypes = async ({
  make,
  model,
  bodyType,
  color,
  transmissionType,
  mileageBucket,
}) => {
  const params = {};
  if (make) params.make = make;
  if (model) params.model = model;
  if (bodyType?.length) params.bodyType = bodyType;
  if (color) params.color = color;
  if (transmissionType?.length) params.transmissionType = transmissionType;
  if (mileageBucket) params.mileageBucket = mileageBucket;

  const r = await api.get("/vehicles/facets/fuel-types", { params });
  return r.data;
};

export const getTransmissions = async ({
  make,
  model,
  bodyType,
  color,
  fuelType,
  mileageBucket,
}) => {
  const params = {};
  if (make) params.make = make;
  if (model) params.model = model;
  if (bodyType?.length) params.bodyType = bodyType;
  if (color) params.color = color;
  if (fuelType?.length) params.fuelType = fuelType;
  if (mileageBucket) params.mileageBucket = mileageBucket;

  const r = await api.get("/vehicles/facets/transmissions", { params });
  return r.data;
};

export const getMileageBuckets = async ({
  make,
  model,
  bodyType,
  color,
  fuelType,
  transmissionType,
}) => {
  const params = {};
  if (make) params.make = make;
  if (model) params.model = model;
  if (bodyType?.length) params.bodyType = bodyType;
  if (color) params.color = color;
  if (fuelType?.length) params.fuelType = fuelType;
  if (transmissionType?.length) params.transmissionType = transmissionType;

  const r = await api.get("/vehicles/facets/mileage-buckets", { params });
  return r.data;
};

export async function getBulkUploadInfo() {
  const res = await api.get("/vehicles/bulk-upload-info");
  return res.data;
}

export const getSuggestions = (q) =>
  api.get("/vehicles/suggestions", { params: { q } }).then((res) => res.data);
